import React from 'react';
import possibilityImage from '../../assets/title.jpg';
import './possibility.css';
import { Link } from 'react-router-dom';

const Possibility = () => (
  <div className="gpt3__possibility" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="Learning possibilities" />
    </div>
    <div className="gpt3__possibility-content">
      <span className="gpt3__possibility-tag">Why Choose Us</span>
      <h1 className="gradient__text">Unlock your child's true potential</h1>
      <p>
        Education shapes a child's confidence, social skills, and future. Our expert tutors provide personalised guidance that goes beyond textbooks — helping students interact, grow, and thrive in an ever-changing world.
      </p>
      <Link to="/contact" className="gpt3__possibility-cta">Get Early Access</Link>
    </div>
  </div>
);

export default Possibility;